/** Shown before login when no tenant is known — override via `.env`: REACT_APP_PUBLIC_APP_NAME */
export const PUBLIC_APP_NAME = (process.env.REACT_APP_PUBLIC_APP_NAME || '').trim() || 'Operations';
